import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-arrow-dotted",
  "use": "app-icon-arrow-dotted-usage",
  "viewBox": "0 0 151 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 151 17\" id=\"app-icon-arrow-dotted\"><path d=\"M70 5.5h4v6H0v-6h70zm69.5 6H136v-6h3.5v-5l11 8-11 8v-5zm-61.5 0v-6h4v6h-4zm9 0v-6h4v6h-4zm8 0v-6h4v6h-4zm8 0v-6h4v6h-4zm8 0v-6h4v6h-4zm8 0v-6h4v6h-4zm9 0v-6h4v6h-4z\" fill=\"#3DCCA6\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol